"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LoginWidgetState = /** @class */ (function () {
    function LoginWidgetState() {
        this.userID = '';
        this.isUserIDinValid = false;
        this.userIDErrorMessage = '';
        this.errorMessage = '';
        this.saveUserIDList = [];
        this.saveId = false;
        this.savedUserIDExists = false;
        this.passwordValue = '';
        this.isPasswordinValid = false;
        this.passwordErrorMessage = '';
        this.capsWarning = false;
        this.showHidePasswordIsHidden = true;
        this.isNumberFormat = false;
        this.errorMessageCounter = 0;
        this.disabled = false;
    }
    return LoginWidgetState;
}());
exports.default = LoginWidgetState;
//# sourceMappingURL=LoginWidgetState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/panels/LoginWidget/LoginWidgetState.js
// module id = 1485
// module chunks = 8